import Cookies from "js-cookie";

export default function CookieBanner() {
  const cookieBanner = document.querySelector(".js-cookie-banner");
  if (cookieBanner) {
    const cookieBannerButton = cookieBanner.querySelector(
      ".js-cookie-banner-button",
    );
    const cookieName = "eghCookieBannerSeen";
    const showClass = "cookie-banner__show";

    const cookie = Cookies.get(cookieName);

    if (cookie !== "true") {
      cookieBanner.classList.add(showClass);
    }

    const handleBannerClick = () => {
      Cookies.set(cookieName, true, { secure: true });
      cookieBanner.classList.remove(showClass);
    };

    cookieBannerButton &&
      cookieBannerButton.addEventListener("click", () => handleBannerClick());
  }
}
